export default function Ticker({ certs }) {
  if (!certs || !certs.length) return null;
  const items = [...certs, ...certs, ...certs, ...certs];
  return (
    <div style={{ background: "#0b1f3a", borderTop: "1px solid rgba(232,89,60,.1)", padding: "11px 0", overflow: "hidden" }}>
      <div style={{ display: "flex", animation: "tk 40s linear infinite", width: "max-content" }}>
        {items.map((c, i) => (
          <div key={i} style={{ display: "inline-flex", alignItems: "center", gap: 9, padding: "4px 34px", borderRight: "1px solid rgba(255,255,255,.08)", flexShrink: 0 }}>
            <span style={{ fontSize: 18 }}>{c.ic}</span>
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#F2A623", lineHeight: 1.2 }}>{c.code}</div>
              <div style={{ fontSize: 10, color: "rgba(255,255,255,.5)" }}>{c.label}</div>
            </div>
            <span style={{ background: "rgba(34,197,94,.18)", color: "#4ade80", fontSize: 9, fontWeight: 800, padding: "2px 8px", borderRadius: 20 }}>CERTIFIED</span>
          </div>
        ))}
      </div>
    </div>
  );
}
